<!-- <div class="mb-1">
  <input
    pInputText
    type="text"
    #inputFilter
    (input)="dt1.filterGlobal(inputFilter.value, 'contains')"
    placeholder="Cerca per seriale..."
    class="w-full"
  />
</div> -->
<form
  [formGroup]="frm_search"
  class="p-fluid grid"
  *ngIf="selection">
  <!-- ricerca per seriale -->
  <div class="col-12 flex align-items-center gap-2">
    <span class="p-input-icon-left flex-grow-1">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        placeholder="Cerca serial number..."
        aria-label="Cerca serial number"
        formControlName="search" />
    </span>
    <p-button
      label="Incolla elenco"
      icon="pi pi-clipboard"
      styleClass="butt p-button-outlined p-button-sm white-space-nowrap"
      pTooltip="Incolla un elenco di seriali (CSV, una colonna di Excel...): quelli trovati vengono selezionati e per gli altri viene indicato il motivo"
      tooltipPosition="bottom"
      (onClick)="togglePaste()"></p-button>
  </div>
</form>

<!-- elenco di seriali incollato -->
<div
  class="paste-panel mt-2"
  *ngIf="selection && pasteOpen">
  <textarea
    pInputText
    rows="5"
    class="w-full"
    placeholder="Incolla qui i seriali, separati da virgola, punto e virgola o a capo"
    aria-label="Elenco di seriali"
    [formControl]="pasteText"></textarea>
  <div class="flex justify-content-between align-items-center mt-2">
    <small class="grey-text">{{ pasteCount }} seriali distinti nell'elenco</small>
    <div class="flex gap-2">
      <p-button
        label="Chiudi"
        styleClass="butt p-button-text p-button-sm"
        (onClick)="closePaste()"></p-button>
      <p-button
        label="Cerca e seleziona"
        icon="pi pi-check"
        styleClass="butt p-button-sm"
        [loading]="pasting"
        [disabled]="!pasteText.value.trim()"
        (onClick)="applyPastedList()"></p-button>
    </div>
  </div>
</div>

<!-- esito dell'elenco incollato -->
<div
  class="paste-report mt-2"
  *ngIf="selection && (pasteReport || pasteError)">
  <p-message
    *ngIf="pasteError"
    severity="error"
    styleClass="w-full"
    text="Impossibile completare la ricerca dei seriali. Riprova."></p-message>
  <ng-container *ngIf="pasteReport as r">
    <div class="flex justify-content-between align-items-center">
      <span class="font-bold"
        >Selezionati {{ r.selectable.length - pasteOverLimit.length }} su
        {{ r.requested }} seriali richiesti</span
      >
      <p-button
        icon="pi pi-times"
        [text]="true"
        styleClass="p-button-sm"
        pTooltip="Chiudi l'esito"
        tooltipPosition="left"
        (onClick)="clearPasteReport()"></p-button>
    </div>
    <ul class="report-summary">
      <li *ngIf="pasteOverLimit.length > 0">
        <i class="pi pi-exclamation-triangle"></i> {{ pasteOverLimit.length }} non selezionati:
        quantità massima raggiunta ({{ qtyLimit }})
      </li>
      <li *ngIf="r.blocked.length > 0">
        <i class="pi pi-lock"></i> {{ r.blocked.length }} trovati ma non selezionabili
      </li>
      <li *ngIf="r.notFound.length > 0">
        <i class="pi pi-times-circle"></i> {{ r.notFound.length }} non trovati
      </li>
      <li *ngIf="r.duplicates.length > 0">
        <i class="pi pi-clone"></i> {{ r.duplicates.length }} ripetuti nell'elenco (ignorati)
      </li>
    </ul>

    <details
      *ngIf="r.notFound.length > 0"
      open>
      <summary>
        Non trovati ({{ r.notFound.length }})
        <p-button
          label="Copia seriali"
          icon="pi pi-copy"
          [text]="true"
          styleClass="p-button-sm"
          (onClick)="copyNotFound(); $event.preventDefault()"></p-button>
        <small *ngIf="notFoundCopied">Copiati</small>
      </summary>
      <ul class="report-list">
        <li *ngFor="let n of r.notFound">
          <b>{{ n.serial }}</b> — {{ n.reason }}
        </li>
      </ul>
    </details>

    <details *ngIf="r.blocked.length > 0">
      <summary>Trovati ma non selezionabili ({{ r.blocked.length }})</summary>
      <ul class="report-list">
        <li *ngFor="let b of r.blocked">
          <b>{{ b.serial }}</b> — {{ b.reason }}
        </li>
      </ul>
    </details>

    <details *ngIf="r.duplicates.length > 0">
      <summary>Ripetuti nell'elenco ({{ r.duplicates.length }})</summary>
      <ul class="report-list">
        <li *ngFor="let d of r.duplicates">{{ d }}</li>
      </ul>
    </details>
  </ng-container>
</div>

<ng-container *ngIf="!loadedAllAssets">
  <p-table
    [value]="[]"
    [paginator]="true"
    [rows]="25"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali"
    [loading]="true">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th *ngIf="selection"></th>
        <th>Serial number</th>
        <th>Utilizzo</th>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
<ng-container *ngIf="loadedAllAssets">
  <p-table
    [value]="assets"
    #dt1
    dataKey="id"
    [rowSelectable]="isRowSelectable"
    [loading]="loading && !loadedAllAssets"
    [selection]="selectedAssets"
    (selectionChange)="onSelectionChange($event)"
    [selectionMode]="'multiple'">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th *ngIf="selection">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th>Serial number</th>
        <th>Asset code</th>
        <th>Utilizzo</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-s>
      <tr>
        <td *ngIf="selection">
          <p-tableCheckbox
            [value]="s"
            [disabled]="
              (s.related_delivery_id && s.related_delivery_id !== related_delivery_id) ||
              (limitReached && !isSelected(s))
            "></p-tableCheckbox>
          <!-- <p-checkbox
          [disabled]="s.related_delivery_id && s.related_delivery_id !== related_delivery_id"
          [(ngModel)]="selectedAssets"
          [value]="s"
          [trueValue]="s" /> -->
        </td>
        <td>
          <ng-container *ngIf="selection"
            >{{ s.serial_number }} ({{ s.asset_code || '-' }})</ng-container
          >
          <p-chip
            *ngIf="!selection"
            [label]="s.serial_number + ' (' + (s.asset_code || '-') + ')'"></p-chip>
        </td>
        <td>
          {{ s.asset_code || 'N.D.' }}
        </td>
        <td>{{ s | assetUtilizzo }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="4"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-paginator
    (onPageChange)="onPageChange($event)"
    [first]="frm_search.get('skip')!.value!"
    [rows]="frm_search.get('pageSize')!.value!"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali" />
</ng-container>
<div class="modal-footer">
  <div
    class="flex justify-content-between"
    *ngIf="selection">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <span
      class="selection-counter align-self-center"
      [class.over-limit]="overQtyLimit"
      [pTooltip]="
        overQtyLimit
          ? 'Hai selezionato più seriali della quantità richiesta (' + qtyLimit + ')'
          : ''
      "
      tooltipPosition="top">
      <i
        class="pi pi-exclamation-triangle"
        *ngIf="overQtyLimit"></i>
      Selezionati: {{ selectedCount }}<ng-container *ngIf="maxSelectable != null"> / {{ maxSelectable }}</ng-container
      ><ng-container *ngIf="manualCount > 0"> (+ {{ manualCount }} inseriti a mano)</ng-container
      ><ng-container *ngIf="limitReached"> - massimo raggiunto</ng-container>
    </span>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
